import { render, staticRenderFns } from "./DutyMatching.vue?vue&type=template&id=9aabe828"
import script from "./DutyMatching.vue?vue&type=script&lang=js"
export * from "./DutyMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports